import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { Row } from 'components/Layout/Grid';
import TextButton from 'components/TextButton';
import { eventName } from 'components/ApplicationInsights/eventNames';
import Animated from 'components/Animated';
import toast from 'components/Toast/dispatch';
import { Visibility } from 'components/Visibility';
import OptionsDownloadInLotCte from './Cte';
import OptionsDownloadInLotOrders from './Orders';

import iconDownloadLot from 'img/icon-download.svg';

import { EnumCTEsTabs } from 'models/CTEs';
import { OrdersTabs } from 'models/Order';

import { DownloadType, OptionsDownloadInLotProps } from './interface';

import DownloadService from 'services/download.service';

import './styles.scss';

const OptionsDownloadInLot: React.FC<OptionsDownloadInLotProps> = (props) => {
  const {
    handleCloseDownloadInLot,
    titleRequestDownload,
    messageRequestDownload,
    selectedOrderDownloadInLot
  } = props;

  const user = useSelector((state: RootState) => state.user);
  const currentTabId = useSelector((state: RootState) => state.currentTab?.currentNameTab);

  const _downloadService = new DownloadService();

  const handleSendRequestDownloadInLot = async (orderAttachmentType: number, downloadType: number) => {

    if (selectedOrderDownloadInLot?.length > 0) {
      const arrayOrder: string[] = selectedOrderDownloadInLot.map(order => order.id);
      await _downloadService.DownloadInLot(user?.id, arrayOrder, orderAttachmentType, downloadType);

      if (titleRequestDownload && messageRequestDownload) {
        toast.info(
          titleRequestDownload,
          messageRequestDownload,
          iconDownloadLot
        );
      }
    } else {
      toast.error('Você precisa selecionar no mínimo 1 pedido para fazer o download');
    }
  };

  const isTabsOrder = currentTabId ? OrdersTabs.includes(currentTabId) : false;
  const isTabCte = currentTabId === EnumCTEsTabs.LISTAGEM_CTES;

  return (
    <Row className={` container-buttons-download ${user?.userType === "customer" ? "customer-buttons" : "employee-buttons"}`}>
      <Animated className="test"
        show
        animationIn="fadeIn"
        animationInDelay="fast"
        animationOut="fadeOutLeft"
        animationOutDelay="fast"
      >
        <Row className="buttons-in-column">
          <Visibility visible={isTabsOrder}>
            <OptionsDownloadInLotOrders
              handleSendRequestDownloadInLot={
                (orderAttachmentType: number) => handleSendRequestDownloadInLot(orderAttachmentType, DownloadType.ORDER)
              }
            />
          </Visibility>

          <Visibility visible={isTabCte}>
            <OptionsDownloadInLotCte
              handleSendRequestDownloadInLot={
                (orderAttachmentType: number) => handleSendRequestDownloadInLot(orderAttachmentType, DownloadType.CTE)
              }
            />
          </Visibility>

          <TextButton
            title="Cancelar"
            onSendRequest={() => handleCloseDownloadInLot()}
            loading={false}
            trackName={eventName.PEDIDOS}
            className="mr-3" />
        </Row>
      </Animated>
    </Row >
  );
};

export default OptionsDownloadInLot;